import DateFormat from '@/lib/Dates/DateFormat';
import moment from 'moment';
import PaymentMethodRef from '@/lib/PaymentMethods/PaymentMethodRef';
import { container } from '@/container';
import { fromMinorUnit } from '@/functions/math';

export const PrintPayyoReceiptMixin = {
    computed: {
        /**
         * @return {boolean}
         */
        hasPayyoPayments() {
            return !!this.order.payments.find((p) => p.isPayyo());
        },
    },

    methods: {
        async printPayyoReceipts() {
            this.isPrinting = true;
            try {
                const filteredPayments = this.order.payments.filter(
                    (payment) => payment.paymentMethod.ref === PaymentMethodRef.CARD_PAYYO_CHIP_AND_PIN
                );

                if (filteredPayments.length > 0) {
                    const branch = this.order.orderBranchID
                        ? container.userService.getBranchByID(this.order.orderBranchID)
                        : null;
                    const company = container.userService.company;
                    const device = container.currentDevice.getDevice();

                    for (const payment of filteredPayments) {
                        await container.receiptPrinter.printPayyoCardReceipt({
                            payment: this.mapPaymentToPayyoReceiptData(payment),
                            branch,
                            company,
                            device,
                        });
                    }
                }
            } catch (e) {
                container.toastFactory.errorTop('PAYYO.PRINT_ERROR', e.message);
            }
            this.isPrinting = false;
        },

        /**
         * @param {Payment} payment
         *
         * @returns {{}}
         */
        mapPaymentToPayyoReceiptData(payment) {
            let p = {};
            p.authCode = payment.authCode;
            p.transactionRef = payment.transactionRef;
            p.amount = payment.amount;
            p.thirdPartyID = payment.thirdPartyID;
            try {
                const statusDetail = JSON.parse(payment.statusDetail);
                if (statusDetail.createdAt) {
                    p.createdAt = moment(statusDetail.createdAt).format(DateFormat.DATE_WITH_TIME_WITH_SECS);
                } else {
                    p.createdAt = moment(payment.takenAt).format(DateFormat.DATE_WITH_TIME_WITH_SECS);
                }

                if (statusDetail.captured) {
                    // Includes amount + any gratuity.
                    p.amount = fromMinorUnit(statusDetail.captured);
                }

                p.scheme = statusDetail.scheme || null;
                p.name = statusDetail.name || null;
                p.last4 = statusDetail.last4 || null;
                p.aid = statusDetail.aid || null;
                p.originalPaymentId = statusDetail.payment_id || null;
                p.merchantId = statusDetail.merchantId || null;
                p.terminalId = statusDetail.deviceId || null;
                p.method = statusDetail.method || null;
                p.verification = statusDetail.verification || null;
                p.status = statusDetail.status || null;
            } catch (e) {
                // Just log the error - the user should at least receive a very minimal receipt.
                console.log(e);
            }
            return p;
        },
    },
};
